import { render, staticRenderFns } from "./blockCo.vue?vue&type=template&id=3f1522e6&scoped=true"
import script from "./blockCo.vue?vue&type=script&lang=js"
export * from "./blockCo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1522e6",
  null
  
)

export default component.exports